import {Outright} from "../../model/EstateFlowchartTypes";
import {ValidationError, ValidationErrorType} from "../ValidationTypes";

export const validateOutrights = (outrights: Outright[]): ValidationError[] => {
    let validationErrors = [] as ValidationError[];

    if (outrights && outrights.length > 0) {
        outrights.forEach((outright) => {
            if (!outright.outrightMembers || outright.outrightMembers?.length === 0) {
                validationErrors.push({
                    type: ValidationErrorType.REQUIRED_FIELDS,
                    property: 'outrightMembers',
                    parent: outright.name,
                    error: 'At least one recipient is required.'
                });
            }
        });
    }

    return validationErrors;
}